<script lang="ts" setup>
import type { FieldData } from '~~/server/api/forms/form'

export interface FormKitCustomRangeProps {
    data: FieldData
}

const props = defineProps<FormKitCustomRangeProps>()
const value = ref<number>(props.data.min || 0)
</script>
<template>
  <div
    class="mb-6"
    data-type="range"
  >
    <label class="formkit-label">
      <input
        v-model="value"
        type="range"
        class="formkit-input"
        :min="props.data.min"
        :max="props.data.max"
        :step="props.data.step"
        :name="props.data.name"
      >
    </label>
    <div class="row g-0 mt-2">
      <div class="col-3 fs-smaller ps-2">
        {{ props.data.min }}
      </div>
      <div class="col-6 d-flex justify-content-center">
        <Tag
          size="small"
          text-color="white"
        >
          {{ value }}
        </Tag>
      </div>
      <div class="col-3 text-end fs-smaller pe-2">
        {{ props.data.max }}
      </div>
    </div>
    <div
      v-if="props.data.help"
      class="formkit-help"
    >
      {{ props.data.help }}
    </div>
  </div>
</template>
